import { render, staticRenderFns } from "./orderconsent.vue?vue&type=template&id=c38621c8&scoped=true"
import script from "./orderconsent.vue?vue&type=script&lang=js"
export * from "./orderconsent.vue?vue&type=script&lang=js"
import style0 from "./orderconsent.vue?vue&type=style&index=0&id=c38621c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38621c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c38621c8')) {
      api.createRecord('c38621c8', component.options)
    } else {
      api.reload('c38621c8', component.options)
    }
    module.hot.accept("./orderconsent.vue?vue&type=template&id=c38621c8&scoped=true", function () {
      api.rerender('c38621c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/orderconsent.vue"
export default component.exports